import html from "./FormStep.html"
import { getDefaultSurveyQuestionResult } from "../../../components/Survey/Util/getDefaultSurveyQuestionResult";
import "../SurveyReactComponent"
import * as surveyResultHelper from "../../../helpers/surveyResultHelper"
import { renderFormStepToHtml } from "../../../components/Survey/Components/FormStepToHtml/FormStepToHtml";

var module = angular.module("ResearchKitApplicationModule");

module.directive("formStep",
	function () {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			}
		};
	}
);

module.controller("formStepController", ["$scope",
	function ($scope) {
		$scope.resultChanged = function (result) {
			$scope.stepManager.setChildResult(result.Identifier, result);
			$scope.stepManager.resultDidChange();
			if (!$scope.$$phase && !$scope.$root.$$phase) {
				$scope.$apply();
			}
		}

		$scope.submitForm = function () {
			$scope.$apply(function () {
				$scope.stepManager.continue();
			});
		}

		let formProps = null;
		$scope.getFormProps = function () {
			var newFormProps = {
				key: $scope.stepManager.step.identifier,
				formItems: $scope.stepManager.getFormItems(),
				results: [...$scope.stepManager.childResults],
				onResultChange: $scope.resultChanged,
				onEnterPressed: $scope.submitForm,
				variant: $scope.stepManager.getFormStyle(),
				contentItemSettings: $scope.stepManager.getContentItemSettings()
			};
			if (!angular.equals(newFormProps, formProps)) {
				formProps = newFormProps;
			}
			return formProps;
		}
	}
]);

module.factory("FormStepManager", ["StepManager", "predicateEvaluator", function (StepManager, predicateEvaluator) {
	function FormStepManager(step, surveyManager) {
		StepManager.call(this, step, surveyManager);
	}
	FormStepManager.prototype = Object.create(StepManager.prototype);

	FormStepManager.prototype.initializeResults = function (previousResult) {
		for (var i = 0; i < this.step.formItems.length; i++) {
			var identifier = this.step.formItems[i].identifier;
			var previousQuestionResult = previousResult ? previousResult.QuestionResults.find(r => r.Identifier.toLowerCase() === identifier.toLowerCase()) : null;

			const getResultType = () => {
				if (this.step.formItems[i].answerFormat?.type === "FileAnswerFormat") {
					return "FileResult";
				}
				if (this.step.formItems[i].answerFormat?.type === "SignatureAnswerFormat") {
					return "ConsentSignatureResult";
				}
				return "QuestionResult";
			}

			var restoredQuestionResult = {
				...previousQuestionResult,
				Identifier: identifier,
				Type: getResultType(),
				StartDate: this.presentedDate,
				EndDate: undefined
			};

			let defaultSurveyResult = getDefaultSurveyQuestionResult(this.step.formItems[i].identifier, this.step.formItems[i].answerFormat);
			if (!restoredQuestionResult.Answers && defaultSurveyResult.Answers !== undefined) {
				restoredQuestionResult.Answers = defaultSurveyResult.Answers;
			}
			if (!restoredQuestionResult.Signature && defaultSurveyResult.Signature !== undefined) {
				restoredQuestionResult.Signature = defaultSurveyResult.Signature;
			}

			this.childResults.push(restoredQuestionResult);
		}
		this.resultDidChange();
	};

	FormStepManager.prototype.continueDisabled = function () {
		var base = this;

		function answerIsInvalid(formItem) {
			var result = base.getChildResult(formItem.identifier);

			if (!result) return false;

			return result.invalid;
		}

		let anyAnsweredQuestions = false;
		let anyVisibleQuestions = false;
		let visibleFormItems = this.step.formItems.filter(f => !base.hideFormItem(f));
		for (var i = 0; i < visibleFormItems.length; i++) {
			let item = visibleFormItems[i];
			if (answerIsInvalid(item)) {
				return true;
			}

			const result = base.getChildResult(item.identifier);
			const resultHasAnswer = item.answerFormat && surveyResultHelper.hasAnswer(result);
			if (resultHasAnswer) {
				anyAnsweredQuestions = true;
			} else if (item.answerFormat && !item.optional) {
				return true; //early return because we found an unanswered required question
			}

			if (item.answerFormat) {
				anyVisibleQuestions = true;
			}
		}

		return !anyAnsweredQuestions && anyVisibleQuestions;

	};
	FormStepManager.prototype.canContinue = function () {
		return !this.continueDisabled() || this.step.optional !== false;
	};

	FormStepManager.prototype.setResultHiddenState = function (item, hidden) {
		var childResult = this.getChildResult(item.identifier);
		if (hidden) {
			childResult.hidden = true;
		}
		else {
			delete childResult.hidden;
		}
	}

	FormStepManager.prototype.hideFormItem = function (item) {
		if (!item.hidePredicate || this.surveyManager.editMode) return false;

		var activeManagedResults = this.surveyManager.getActiveManagedResults();
		var hideItem = predicateEvaluator.evaluatePredicate(item.hidePredicate, activeManagedResults);
		this.setResultHiddenState(item, hideItem);
		return hideItem;
	}

	FormStepManager.prototype.getFormItems = function () {
		return this.step.formItems.filter(s => !this.hideFormItem(s));
	};

	return FormStepManager;
}]);

module.factory("ConsentFormStepManager", ["FormStepManager", "predicateEvaluator", "$translate", function (FormStepManager, predicateEvaluator, $translate) {
	function ConsentFormStepManager(step, surveyManager) {
		FormStepManager.call(this, step, surveyManager);
	}
	ConsentFormStepManager.prototype = Object.create(FormStepManager.prototype);

	ConsentFormStepManager.prototype.continue = function () {
		if (!this.surveyManager.stepCanContinue(this)) {
			return false;
		}

		this.dismissedDate = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
		const result = this.getResult();
		const consentDocumentContent = renderFormStepToHtml(this.surveyManager.template, this.step, result.QuestionResults, $translate);
		result.ConsentDocumentContent = consentDocumentContent;
		result.ConsentDocumentTitle = this.step.title;
		this.surveyManager.setManagedResult(result, this.step.identifier);
		this.surveyManager.stepDidFinish(this, true);
		return true;
	}

	return ConsentFormStepManager;
}]);